import { gql } from 'apollo-boost';
import { useMutation } from '../';

const query = gql`
  mutation nextQuestion (
      $reportId: Int!,
      $section: String,
  ) {
    nextQuestion (
      reportId: $reportId,
      section: $section,
  ) {
      success
      nextQuestion
    }
  }
`;

export function useNextQuestion() {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    mutate(query, variables, (response) => {
      if (typeof onFinish === 'function') {
        onFinish(response.nextQuestion.nextQuestion);
      }
    });
  };
  return { data, isLoading, run };
}
